import styled from "styled-components";

interface RadialChartStyleProps {
  $color: "yellow" | "green" | "red" | undefined;
}

export const RadialChart = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  z-index: 10;
`;

export const RadialChartUnit = styled.div<RadialChartStyleProps>`
  position: absolute;
  display: flex;
  width: 64px;
  height: 64px;
  top: 8px;
  padding-top: 24px;
  color: ${(props) => props.theme.colors.text450};
  font-size: 1rem;
  background: ${(props) => props.theme.colors.primaryBg20};
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  z-index: 9;
`;
